import type { ReactNode } from "react";

import { PopupMenu } from "@/features/app/components/modals/PopupMenu";
import { Color } from "@/features/utils/color";

import "./layer-selection-popup-item.scss";

export const LayerSelectionPopupItem = (props: {
  icon: ReactNode;
  name: string;
  featureType: string;
  featureColor: string;
  onClick: () => void;
}) => {
  const textColor = new Color(props.featureColor).contrastingColor();

  return (
    <PopupMenu.Item
      icon={
        <span
          className="layer-selection-popup-item__feature-type"
          style={{
            backgroundColor: props.featureColor,
            color: textColor.hex(),
          }}
        >
          {props.icon}
          {props.featureType}
        </span>
      }
      text={props.name}
      onClick={props.onClick}
    />
  );
};
